import { createFileRoute } from '@tanstack/react-router';

import { AnalyticsMoveReportPage } from '@pages/analytics';
import { ANALYTICS_MOVE_TAB_REGISTRATIONS } from '@pages/analytics/ui/analytics-move-tabs';
import { Skeleton, Stack } from '@shared/ui';

export const Route = createFileRoute('/$locale/_authenticated/analytics-move/registrations')({
  component: AnalyticsMoveRegistrationsRoute,
  pendingComponent: AnalyticsMoveRegistrationsPending,
  pendingMs: 0,
  pendingMinMs: 0,
});

function AnalyticsMoveRegistrationsRoute() {
  return <AnalyticsMoveReportPage activeTab={ANALYTICS_MOVE_TAB_REGISTRATIONS} />;
}

function AnalyticsMoveRegistrationsPending() {
  return (
    <Stack gap="md" data-testid="analytics-registrations-pending">
      <Skeleton className="h-10 w-72" />
      <Skeleton className="h-10 w-full" />
      <div className="space-y-3">
        {Array.from({ length: 4 }).map((_, index) => (
          <Skeleton key={`registrations-pending-${String(index)}`} className="h-40 w-full" />
        ))}
      </div>
    </Stack>
  );
}
